
;(function($, window, document) {
 
  const modals = $('.modal');

  // Apply the no-scroll to the page
  if (modals.length > 0) {
    $('html').addClass('noscroll');

    const tabbables = $('.modal').find('select, input, textarea, button, a');

    const first = tabbables.first();
    const last = tabbables.last()

    first.trigger('focus');

    /* Redirect last tab to first input */
    last.on('keydown', function (e) {
      if ((e.which === 9 && !e.shiftKey)) {
        e.preventDefault();
        first.trigger('focus');
    }
    });

    /* Redirect first shift+tab to last input */
    first.on('keydown', function (e) {
    if ((e.which === 9 && e.shiftKey)) {
      e.preventDefault();
      last.trigger('focus');
    }
    });




    // Setting ARIA status
    $('.modal').siblings('.block').attr('aria-hidden', true);
    $('.site-header, .site-footer, .skip-link').attr('aria-hidden', true);
    
  }



  // Focus trapping
  $('.modal').on('keydown', ($event) => {

    const e = $event.originalEvent;

    if (e && e.code === "Escape") {
      close_modal();
    }
  });


  $('.btn-close-modal').on('click', function() {
    close_modal();
  });

  function close_modal() {
    $('html').removeClass('noscroll');
    $('.modal').remove();

    $('.modal').siblings('.block').attr('aria-hidden', false);
    $('.site-header, .site-footer').attr('aria-hidden', false);
  }

})(jQuery, window, document);